import { LogicProposalComponent } from "lib/frontend/cm/utils/types";
import { VariableInputMode, User } from "prisma/cm/client";

import { Proposal } from "./types";

function getBonusTargetEngineResults(proposal: Proposal) {
  // @ts-expect-error TS7006
  return proposal.logicSuggestedValues?.[LogicProposalComponent.BONUS_TARGET]?.engineResults;
}

export function getSuggestedBonusTargetPercent(proposal: Proposal) {
  const override = proposal.suggestedBonusTargetPercent;

  if (override) {
    return override;
  }

  const engineResults = getBonusTargetEngineResults(proposal);
  return engineResults?.suggestedBonusTargetPercent;
}

export function getLogicComputedBonusTarget(proposal: Proposal) {
  const engineResults = getBonusTargetEngineResults(proposal);

  return engineResults?.reviewSuggestion;
}

export function getSuggestedBonusTargetNominal(proposal: Proposal) {
  const override = proposal.suggestedBonusTargetNominal;

  if (override) {
    return override;
  }

  const engineResults =
    // @ts-expect-error TS7006
    proposal.logicSuggestedValues?.[LogicProposalComponent.BONUS_TARGET]?.engineResults;

  return engineResults?.suggestedBonusTargetNominal;
}

export function getSuggestedBonusTarget(proposal: Proposal) {
  const inputMode = getBonusTargetInputMode(proposal);

  if (inputMode === VariableInputMode.PERCENT) {
    return getSuggestedBonusTargetPercent(proposal);
  } else {
    return getSuggestedBonusTargetNominal(proposal);
  }
}

export function hasBonusTargetBeenManuallyEdited<
  T extends { preventAutoAccept: Proposal["preventAutoAccept"] },
>(proposal: T) {
  return proposal.preventAutoAccept?.[LogicProposalComponent.BONUS_TARGET] === true;
}

export function getBonusTargetInputMode(proposal: Proposal & { owner?: User }) {
  return (
    proposal?.bonusTargetInputMode ??
    proposal?.owner?.bonusTargetInputMode ??
    VariableInputMode.PERCENT
  );
}
